import type { Theme } from '@mui/material';

export const styles = {
  container: {
    p: 0,
  },
  divider: (theme: Theme) => ({
    borderColor: theme.colors.neutral[100],
    mb: 2,
  }),

  title: {
    pb: 1,
  },

  itemContainer: (theme: Theme) => ({
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: '4px',
    p: 1,
  }),

  radio: (theme: Theme, isSelected: boolean) => ({
    p: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
    },
    color: theme.colors.neutral[200],
    '&.Mui-checked': {
      color: isSelected ? theme.colors.primary[500] : theme.colors.neutral[200],
    },
  }),

  contentContainer: {
    flex: 1,
  },

  progressContainer: (theme: Theme) => ({
    display: 'flex',
    backgroundColor: theme.colors.success[50],
    height: '2.5rem',
    p: theme.spacing(2),
    borderRadius: '0 0 4px 4px',
    borderTop: `5px solid ${theme.colors.success[500]}`,
  }),

  progressInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  progressText: (theme: Theme) => ({
    fontSize: '15.25px',
    fontWeight: 700,
    lineHeight: '17px',
    color: theme.colors.green[500],
  }),

  infoIcon: (theme: Theme) => ({
    marginTop: '4px',
    fontSize: '20px',
    color: theme.colors.green[700],
  }),

  expandedContent: (theme: Theme) => ({
    marginLeft: theme.spacing(4),
  }),

  section: {
    m: 1,
  },

  sectionTitle: {},

  textField: {},

  listContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: 1,
    p: 2,
  },

  listItem: {
    marginBottom: '8px',
    '&:last-child': {
      marginBottom: 0,
    },
  },

  error: (theme: Theme) => ({
    color: theme.colors.error[600],
  }),
};
